import { render, staticRenderFns } from "./AppointmentForm.vue?vue&type=template&id=5862bf89&scoped=true&"
import script from "./AppointmentForm.vue?vue&type=script&lang=js&"
export * from "./AppointmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentForm.vue?vue&type=style&index=0&id=5862bf89&lang=scss&scoped=true&"
import style1 from "./AppointmentForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862bf89",
  null
  
)

export default component.exports